/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {noop} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import Backbone from 'backbone';
import classNames from 'classnames';
import React, {MouseEvent} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import * as OnboardingActions from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as ExternalFileDAO from 'dao/ExternalFileDAO';
import * as FileBrowserDAO from 'file-browser/FileBrowserDAO';
import {FileBrowserSearchResults} from 'file-browser/FileBrowserDAO';
import {TabState, TabStateDefaults} from 'Navigation';
import {ExternalProtocol, FromServerProtocol} from 'notebook/ELNConstants';
import {Entry} from 'notebook/entries/backbone/filestate/Entry';
import ProtocolDAO from 'notebook/protocols/dao/ProtocolDAO';
import {DocumentEditorLock} from 'notebook/realtime/reduceDocumentEditorLockState';
import {ExternalFile} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import DocumentEditorLockUtil from 'realtime/util/DocumentEditorLockUtil';
import {BenchlingState} from 'redux-stores/reduceApp';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import EntityStore from 'stores/EntityStore';
import {HasAvatar} from 'ui-library/avatar/Avatar';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import FilesPickerComponent from 'ui-library/FilesPickerComponent';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import Modal from 'ui-library/modals/Modal';
import fuzzydate from 'util/fuzzydate';
import {InputChangeEvent} from 'util/Types';

class NewEntryProtocolTabState extends TabState {
  override defaults(): TabStateDefaults {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'Add Protocol',
      closeable: false,
      options: true,
      showInNavBar: true,
      draggable: false,
      preferenceKey: 'new-entry-protocol',
    });
  }

  file(): Entry {
    return this.get('file');
  }

  addProtocol(protocol: ExternalProtocol | FromServerProtocol): void {
    this.file().addProtocol(protocol);
  }
}

interface State {
  query: string;
  loading: boolean;
  results: FileBrowserSearchResults['data'];
  isDocumentEditorLocked: boolean;
}

interface EnhancedProps {
  documentEditorLock?: DocumentEditorLock;
}

export interface NewEntryProtocolTabProps {
  user: HasAvatar;
  fileHandler: (files: Array<File>) => JQueryPromise<void>;
  itemClickHandler: (e: MouseEvent, result: {id: string}) => void;
  fileId: string;
  documentEditorLock?: DocumentEditorLock;
}

// TODO: This should be the FileBrowserSearchResult type, but that's missing modified_at, name, and creator
interface SearchResult {
  id: string;
  name: string;
  modified_at: string;
  creator: HasAvatar;
}

export interface ProtocolSearchResultProps {
  result: SearchResult;
  itemClickHandler: (e: MouseEvent, result: {id: string}) => void;
  locked: boolean;
}

interface FileUploadModalProps {
  fileHandler: (files: Array<File>) => JQueryPromise<void>;
  onRequestClose: () => void;
}

class FileUploadModal extends React.Component<FileUploadModalProps> {
  ref = React.createRef<FilesPickerComponent>();

  override render(): JSX.Element {
    return (
      <Modal
        title="Import protocols from file"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={() => {
          if (this.ref.current != null) {
            this.ref.current.handleUpload({uploadComplete: noop, allComplete: this.props.onRequestClose});
          }
        }}
        buttons={[{text: 'Import', submit: true}]}
      >
        <FilesPickerComponent upload={this.props.fileHandler} ref={this.ref} />
      </Modal>
    );
  }
}

const FILE_UPLOAD_MODAL_KEY = 'FileUploadModal';

export function ProtocolSearchResult(props: ProtocolSearchResultProps): JSX.Element {
  const {result, locked} = props;
  return (
    <div
      className={classNames(css(locked && styles.greyText), 'u-pointer new-entry-protocol-result')}
      onClick={(e) => {
        props.itemClickHandler(e, result);
      }}
    >
      <div>
        <span className="pull-right u-small-text new-entry-protocol-result-date">
          <strong>{fuzzydate(result.modified_at, {days: 7, showTime: false})}</strong>
        </span>
        <BenchlingIcon icon={ModelTypeConstants.PROTOCOL} className="u-small-spacing-right" />
        <strong>{result.name || 'Untitled'}</strong>
      </div>
      <div className="u-small-spacing-top u-small-text new-entry-protocol-description">
        <BenchlingIcon icon="user" className="u-tiny-spacing-right" />
        <span>{result.creator != null ? getPartyDisplayString(result.creator) : undefined}</span>
      </div>
    </div>
  );
}

export class NewEntryProtocolTab extends React.Component<NewEntryProtocolTabProps, State> {
  _isMounted: boolean = false;

  override state: State = {
    query: '',
    loading: true,
    results: [],
    isDocumentEditorLocked: DocumentEditorLockUtil.isLockedInRealtime(this.props.documentEditorLock),
  };

  override componentDidMount(): void {
    this._isMounted = true;
    this.search();
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override componentDidUpdate(prevProps: NewEntryProtocolTabProps): void {
    if (prevProps.documentEditorLock !== this.props.documentEditorLock) {
      this.setState({
        isDocumentEditorLocked: DocumentEditorLockUtil.isLockedInRealtime(this.props.documentEditorLock),
      });
    }
  }

  openFileUploadModal = (): void => {
    LegacyModalContainer.open(
      FILE_UPLOAD_MODAL_KEY,
      <FileUploadModal
        fileHandler={this.props.fileHandler}
        onRequestClose={() => {
          LegacyModalContainer.close(FILE_UPLOAD_MODAL_KEY);
        }}
      />
    );
  };

  handleQueryChange = (e: InputChangeEvent): void => {
    this.setState({query: e.target.value, loading: true});
    this.searchDebounced();
  };

  search = (): void => {
    const searchParams = {
      q: this.state.query,
      filter: ModelTypeConstants.PROTOCOL,
      scope: null,
    };
    FileBrowserDAO.search(searchParams)
      .done(({data}: FileBrowserSearchResults) => {
        if (this._isMounted) {
          this.setState({loading: false, results: data});
        }
      })
      .fail((res) => {
        notifications.notifyError(res);
        if (this._isMounted) {
          this.setState({loading: false});
        }
      });
  };

  searchDebounced = debounce(() => {
    this.search();
  }, 250);

  override render(): JSX.Element {
    return (
      <div>
        <div className="text-center">
          <h4 className="new-protocol-header">
            {'Click on a protocol to add it to your entry or '}
            <Tooltip
              text="Can't add protocol while entry is being edited by another user"
              isDisabled={!this.state.isDocumentEditorLocked}
            >
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                size={ButtonSize.SMALL}
                disabled={this.state.isDocumentEditorLocked}
                onClick={this.openFileUploadModal}
                text="Import from File"
                type="button"
              />
            </Tooltip>
          </h4>
        </div>
        <div>
          <input
            className="new-entry-protocol-query u-width-full"
            value={this.state.query}
            onChange={this.handleQueryChange}
            placeholder="Search your protocols"
          />
          <Tooltip
            text="Can't add protocol while entry is being edited by another user"
            isDisabled={!this.state.isDocumentEditorLocked}
          >
            <div
              className={classNames({
                'is-searching': this.state.loading,
                'new-entry-protocol-results-wrapper': true,
                'scrollbar-override': true,
              })}
            >
              {this.state.results.length ? (
                Array.from(this.state.results).map((result) => (
                  <ProtocolSearchResult
                    result={result as unknown as SearchResult}
                    itemClickHandler={
                      this.state.isDocumentEditorLocked ? () => {} : this.props.itemClickHandler
                    }
                    key={result.id}
                    locked={this.state.isDocumentEditorLocked}
                  />
                ))
              ) : (
                <div className="text-center faded u-spacing-top">No matching protocols found.</div>
              )}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: BenchlingState, props: NewEntryProtocolTabProps): EnhancedProps {
  return DocumentEditorLockUtil.mapDocumentEditorLockStateToProps(state, props.fileId);
}

const ConnectedNewEntryProtocolTab = connect(mapStateToProps)(NewEntryProtocolTab);

class NewEntryProtocolTabView extends Backbone.View<NewEntryProtocolTabState> {
  static initClass(): void {
    this.prototype.className = 'new-entry-protocol buffer-tab buffer-tab--no-padding';
  }

  itemClickHandler(e: MouseEvent, result: {id: string}): void {
    e.preventDefault();
    ProtocolDAO.get(result.id)
      .done((protocol) => {
        if (protocol) {
          this.model.addProtocol(protocol);
          analytics.track('lab_notebook', 'attached_protocol', {
            entry_id: this.model.file().id,
            protocol_id: protocol.id,
            user_created_protocol: protocol.creator.id === EntityStore.currentUser()?.id,
            is_uploaded_protocol: false,
          });
          OnboardingActions.completeOnboardingTask(
            OnboardingConstants.MODULES.ENTRY,
            OnboardingConstants.ATTACH_PROTOCOL
          );
        }
      })
      .fail(notifications.notifyError);
  }

  fileHandler(file: File): JQueryPromise<ExternalFile> {
    return ExternalFileDAO.uploadFile(file)
      .done((externalFile) => {
        if (externalFile) {
          this.model.addProtocol({externalFile});
          analytics.track('lab_notebook', 'attached_protocol', {
            entry_id: this.model.file().id,
            protocol_id: externalFile.id,
            user_created_protocol: true,
            is_uploaded_protocol: true,
          });
          OnboardingActions.completeOnboardingTask(
            OnboardingConstants.MODULES.ENTRY,
            OnboardingConstants.ATTACH_PROTOCOL
          );
        }
      })
      .fail(notifications.notifyError);
  }

  override render(): this {
    renderToDOM(
      <ConnectedNewEntryProtocolTab
        user={EntityStore.currentUser()}
        itemClickHandler={this.itemClickHandler.bind(this)}
        fileHandler={this.fileHandler.bind(this)}
        fileId={this.model.file().id}
      />,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<NewEntryProtocolTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
NewEntryProtocolTabView.initClass();

export {NewEntryProtocolTabView, NewEntryProtocolTabState};

export const styles = StyleSheet.create({
  greyText: {
    color: '#979799',
  },
});
